<template>
    <v-container fluid>
        <v-row class="pt-2" justify="center" align="center">
            <v-col>
                <h1 class="text-center">Contact</h1>
            </v-col>
        </v-row>
        <v-card
            class="mx-auto justify-center pt-2 pb-2"
            flat
        >
            <v-row justify="center" align="center">
                <v-col
                    cols="12"
                    md="6"
                >
                    <v-card-title class="justify-center" v-text=headline></v-card-title>
                    <v-card-text class="text-center">
                        <p 
                            v-for="(item, i) in text_items"
                            :key="i"
                            v-text=item.social_media
                        >
                        </p>
                        <!-- <p 
                            v-for="(item, i) in items"
                            :key="i"
                        >
                            <a :href=item.link v-text=item.social_media></a>
                        </p> -->
                    </v-card-text>
                </v-col>  
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "Contact",
    data: () => ({
        headline: "My email",
        text_items: [{
            social_media: "rcrusel at gmail dot com"
        }],
        items: [{
            social_media: "My LinkedIn",
            link: "https://www.linkedin.com/in/ryan-russell-6457a318b/"
        }]
    })
};
</script>

<style scoped>
</style>